<script setup lang="ts">
import { InputPrimary } from '@shared/ui/input'

import { useTutorApplicationStore } from '../../model/store'
import { useJobPostingSite } from '../../model/additional-questions/job-posting-site.hooks'

defineOptions({
  name: 'InputJobPostingSite',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setJobPostingSite,
} = useJobPostingSite()
</script>

<template>
  <InputPrimary
    id="job-posting-site"
    name="job_posting_site"
    type="text"
    :label="label"
    placeholder="Type answer here"
    :mode="mode"
    error-message="Please enter your job posting site"
    :value="tutorApplicationStore.jobPostingSite"
    @input="setJobPostingSite"
  />
</template>
